/* eslint-disable no-loop-func */
import { MenuItem } from '../components/layout/Layout';
import { SLUG_CATEGORY } from '../styles/slugs';

export const flattenTree = (menu: MenuItem[]) => {
  const flat: MenuItem[] = [];
  menu.forEach((item) => {
    flat.push(item);
    if (item.children) {
      flat.push(...flattenTree(item.children));
    }
  });
  return flat;
};

// construct slug from menu item slug by browsing his parents in menu tree
export const constructCategorySlug = (menu: MenuItem[], item: MenuItem) => {
  const flat = flattenTree(menu);
  let temp = item;
  let slug = SLUG_CATEGORY;
  while (temp?.parentId !== null) {
    const parent = flat.find((i) => i.id === temp?.parentId) as MenuItem;
    slug = slug + '/' + parent?.slug;
    temp = parent;
  }
  return (slug ?? '') + '/' + item.slug;
};

interface BreadCrumb {
  label: string;
  slug: string;
}

export const isInCategory = (menuItem: MenuItem, currentLocation: string) => {
  if (
    currentLocation.includes(`/${SLUG_CATEGORY}/${menuItem.slug}`) ||
    menuItem.children?.filter((item) =>
      currentLocation.includes(`/${SLUG_CATEGORY}/${item.slug}`),
    ).length > 0
  )
    return true;
  return false;
};

export const constructBreadcrumbs = (
  menu: MenuItem[],
  categorySlug: string,
) => {
  const flat = flattenTree(menu);
  let breadcrumbs: BreadCrumb[] = [];
  let breadcrumb: BreadCrumb;
  let categoriesSlug = `/${SLUG_CATEGORY}/`;
  let temp = flat.find((item) => item.slug === categorySlug) as
    | MenuItem
    | undefined;

  while (temp) {
    breadcrumb = { label: temp.name, slug: '' };

    const parent = flat.find((i) => i.id === temp?.parentId);
    breadcrumb.slug = categoriesSlug + temp.slug;
    breadcrumbs.push(breadcrumb);
    temp = parent;
  }
  breadcrumbs.push({ label: 'Boutique', slug: '/' });
  breadcrumbs.reverse();
  return breadcrumbs;
};
